"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var util_1 = require("@aperza/util");
var react_bootstrap_1 = require("react-bootstrap");
var AcModal_1 = require("../modal/AcModal");
var AcButton_1 = __importDefault(require("../button/AcButton"));
var AcToast_1 = require("../notification/AcToast");
var axios = require('axios');
var Cookies = require('js-cookie');
var serverUrl = util_1.AppService.cloudServerHost();
exports.AcSessionTimeOutNotificationDialog = function () {
    var _a = react_1.useState(false), show = _a[0], setShow = _a[1];
    var timeout = 25 * 60 * 1000;
    var createTimeout = function () {
        return setTimeout(function () {
            setShow(true);
        }, timeout);
    };
    var _b = react_1.useState(), timer = _b[0], setTimer = _b[1];
    var cleanUpTimer = function () {
        if (timer) {
            clearTimeout(timer);
        }
    };
    var restartTimer = function () {
        cleanUpTimer();
        setTimer(createTimeout());
    };
    react_1.useEffect(function () {
        if (!timer) {
            restartTimer();
        }
        return function () {
            cleanUpTimer();
        };
    }, []);
    var refreshSession = function () {
        axios({
            method: 'get',
            url: serverUrl + "/fax/api/session",
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': Cookies.get('_ctkn'),
            },
        })
            .then(function (response) {
            if (response.status === 200) {
                AcToast_1.notifyMessage('セッションの有効期限を延長しました。');
            }
            else {
                AcToast_1.notifyMessage('セッションの有効期限を延長に失敗しました。');
            }
        })
            .catch(function () {
            AcToast_1.notifyMessage('セッションの有効期限を延長に失敗しました。');
        });
    };
    var onHide = function () { return setShow(false); };
    var onClick = function () {
        refreshSession();
        restartTimer();
        onHide();
    };
    return (react_1.default.createElement(AcModal_1.AcModal, { show: show, onHide: onHide, level: 2, staticBackdrop: true },
        react_1.default.createElement(react_bootstrap_1.Modal.Body, { className: "p-4" },
            react_1.default.createElement("h4", { className: "h4 text-center mb-6" }, "\u30BB\u30C3\u30B7\u30E7\u30F3\u306E\u6709\u52B9\u671F\u9650\u304C\u307E\u3082\u306A\u304F\u5207\u308C\u307E\u3059\u3002"),
            react_1.default.createElement("p", { className: "text-center" }, "\u30BB\u30C3\u30B7\u30E7\u30F3\u6709\u52B9\u671F\u9650\u3092\u5EF6\u9577\u3057\u307E\u3059\u304B\uFF1F")),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, { className: "d-flex justify-content-center" },
            react_1.default.createElement(AcButton_1.default, { size: "lg", variant: "apzlinkblue", onClick: onClick }, "\u306F\u3044"))));
};
exports.AcSessionTimeOutNotificationDialog.displayName = 'AcSessionTimeOutNotificationDialog';
//# sourceMappingURL=AcSessionTimeOutNotificationDialog.js.map